export default __webpack_public_path__ + "static/media/multi-vision.f8d7d6b1.jpg";